import { render, staticRenderFns } from "./TipoReportePage.vue?vue&type=template&id=2ddb2980"
import script from "./TipoReportePage.js?vue&type=script&lang=js&external"
export * from "./TipoReportePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports